import {FaStar} from 'react-icons/fa'
import {MdLocationOn} from 'react-icons/md'
import {BsFillBriefcaseFill} from 'react-icons/bs'
import './index.css'

const SimilarJobs = props => {
  const {lis} = props
  return (
    <div className="simdiv">
      <div className="simlogo">
        <img
          alt="similar job company logo"
          className="simmg"
          src={lis.companyLogoUrl}
        />
        <div className="stardiv">
          <h1>{lis.title}</h1>
          <div className="simrow">
            <FaStar className="star" />
            <p>{lis.rating}</p>
          </div>
        </div>
      </div>
      <div>
        <h1>Description</h1>
        <p>{lis.jobDescription}</p>
      </div>
      <hr />
      <div>
        <div className="row">
          <div className="row">
            <MdLocationOn className="m" />
            <p>{lis.location}</p>
          </div>
          <div className="row">
            <BsFillBriefcaseFill className="m" />
            <p>{lis.employmentType}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SimilarJobs
